import { cancelButtonProps } from "components/Form/components/CancelButton/CancelButton";

/**
 * Comment delete is irreversible and the delete control sits a single click away
 * next to Reply/Edit, so an accidental click silently loses a comment
 * (operator-task-fe-record-comment-delete-confirmation). The delete is therefore
 * interposed with the app's shared confirmation modal.
 *
 * The modal CONFIG is built here as a pure function so the destructive-action
 * conventions can be unit-tested without rendering the whole panel (mirroring the
 * pure-helper + test pattern already used for commentEdit / commentRead /
 * commentScroll). It reuses the exact conventions every other destructive record
 * action uses: the shared `confirmationModal` class, the danger-styled confirm
 * button (ui-design-principle-buttons: destructive actions use the danger button)
 * and the standard white cancel (`cancelButtonProps`). See showConfirmModal.
 */
export const DELETE_COMMENT_CONFIRM_TITLE = "Delete comment";
export const DELETE_COMMENT_CONFIRM_CONTENT =
    "Are you sure you want to delete this comment? This cannot be undone.";

export const buildDeleteCommentConfirm = (onConfirm: () => void) => ({
    title: DELETE_COMMENT_CONFIRM_TITLE,
    content: DELETE_COMMENT_CONFIRM_CONTENT,
    onConfirm,
    confirmText: "Delete",
    cancelButtonProps,
    confirmButtonProps: { className: "button button--danger" },
    className: "confirmationModal",
    centered: true,
});
